import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p395319106922749952',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
